import { Paper } from "@material-ui/core";
import { useHistory } from "react-router";
import profileImg from "../../images/blank-profile.png";
import playbtn from "../../../../assets/images/playbtn.svg";
import getbackarrow from "../../../../assets/images/getbackarrow.svg";
import { useEffect, useRef } from "react";
import { useDispatch, useSelector } from "react-redux";
import { getAllActivityHistory } from "../../../../Redux/Actions/ActivityHistoryAction";
import CamelCaseString from "../../../../Common/CamelCaseString";
import SharedVideoDetails from "./SharedVideoDetails";
import { CircularProgress } from "@material-ui/core";
import { FaPlay } from "react-icons/fa";
const AllActivity = () => {
  const activityHistoryData = useSelector((state) => state.activityHistoryData);
  const history = useHistory();
  const dispatch = useDispatch();

  useEffect(() => {
    getAllActivityHistory(dispatch, {
      pageNumber: activityHistoryData?.pageNumber,
      status: true,
    });
  }, []);

  const convertArrToString = (name) => {
    let sharedTo = [];
    if (name !== null) {
      const coachesNames = name.filter((item) => item?.firstName != null);
      sharedTo = coachesNames.map((item) => item?.firstName);
    }
    return String(sharedTo).replaceAll(",", ", ");
  };

  const storagePlaylist = (
    seasonId,
    eventType,
    weekName,
    eventCategory,
    offSeasonEventName,
    practiceName,
    otherSeasonId
  ) => {
    switch (eventType) {
      case "Other":
        history.push(
          `/videoplayer?season-year=${otherSeasonId?.schYear}&season-type=${eventType}&event-type=${offSeasonEventName}`
        );
        break;

      case "Off-Season":
        history.push(
          `/videoplayer?season-year=${otherSeasonId.schYear}&season-type=${eventType}&eventname=${offSeasonEventName}&practice=${practiceName}`
        );
        break;

      case "In-Season":
        history.push(
          `/videoplayer?season-year=${seasonId}&season-type=${eventType}&week=${weekName}&event-type=${eventCategory}`
        );
        break;

      default:
        break;
    }
  };

  const MembersAddedContainer = (item, index) => {
    return (
      <div
        className="main-card-box pd-10 brd-grey mg-bottom-20 position-relative"
        key={index}
      >
        <div className="d-flex-align-cent">
          <img
            src={item?.uploadedLogo ? item?.uploadedLogo?.filePath : profileImg}
            className="profile-img"
          />
          <div className="pd-15">
            <p className="font-17 lightblack bold">
              <span className="skBlue">{item?.memberAdded?.firstName}</span> is
              added as{" "}
              <span className="skBlue">
                {CamelCaseString(item?.userRoles[0]?.displayName)}
              </span>{" "}
              by {item?.memberAdded?.memberAddedBy}
            </p>
            <p>{item?.lastSeen}</p>
          </div>
        </div>
      </div>
    );
  };

  const SeasonAddedContainer = (item, index) => {
    return (
      <div
        className="main-card-box pd-10 brd-grey mg-bottom-20 position-relative"
        key={index}
      >
        <div className="d-flex-align-cent">
          <img
            src={item?.uploadedLogo ? item?.uploadedLogo?.filePath : profileImg}
            className="profile-img"
          />
          <div className="pd-15">
            <p className="font-17 lightblack bold">
              <span className="skBlue">{item?.season?.years}</span> Season Added
              by{" "}
              <span className="skBlue">{item?.seasonAddedBy?.firstName}</span>
            </p>
            <p>{item?.lastSeen}</p>
          </div>
        </div>
      </div>
    );
  };

  const EventsAddedContainer = (item, index) => {
    return (
      <div
        className="main-card-box pd-10 brd-grey position-relative"
        key={index}
      >
        <div className="d-flex-space-between flex-wrap w-100 pad-bottom-10  brderbtm d-flex-align-cent">
          <p className="fs-16 semi-bold">
            {item?.memberAdded?.firstName} Added New Schedule
          </p>
          <button
            className="small-btn"
            onClick={() => history.push("/seasons")}
          >
            Show
          </button>
        </div>
        <div className="mg-top-10">
          <p className="bold fs-18 mg-bottom-5">
            {item?.schedule?.seasonWeek.title}
          </p>
          <p className="bold fs-18 mt-1">
            {item?.schedule?.homeSchool?.schoolName}
            <span className="skBlue"> Vs</span>{" "}
            {item?.schedule?.opponent?.schoolName}
          </p>
          <p className="my-1 text-secondary semi-bold">
            Location : {item?.schedule?.location}
          </p>
          <p className="text-secondary semi-bold">
            Date : {item?.schedule?.eventDate}
          </p>
        </div>
      </div>
    );
  };

  const videoEditsContainer = (item, index) => {
    return (
      <div
        className="main-card-box pd-10 brd-grey position-relative"
        key={index}
      >
        <div className="d-flex-space-between flex-wrap w-100 pad-bottom-10  brderbtm">
          <p className="fs-16 semi-bold">
            You were working on this playlist in the library.
          </p>
          <span className="semi-bold">{item?.lastSeen}</span>
        </div>
        <div className="row mg-top-10">
          <div className="col-lg-9 col-md-9">
            <div className="d-flex-space-between mg-top-10">
              <div className="d-flex-align-cent gap-15">
                <div>
                  <FaPlay className="color-main-blue" />
                </div>
                <div className="d-flex-space-between width-100">
                  <p className="bold fs-18">
                    {item?.school1Name}
                    {item?.eventName
                      ? item?.event?.seasonType === "Other"
                        ? " (Other Season)"
                        : " (Off Season)"
                      : ""}
                    {item?.school2Name && <span className="skBlue"> Vs </span>}
                    {item?.school2Name}
                  </p>
                </div>
              </div>
            </div>
            <div className="mg-left-30">
              <p className="mg-bottom-15 mg-top-20">{item?.playlistName}</p>
              <button
                type="button"
                className="btn-back"
                onClick={() =>
                  storagePlaylist(
                    item?.scheduleDetails?.season?.years,
                    item?.event?.seasonType,
                    `${item?.seasonWeeks?.title} - ${item?.school2Name}`,
                    item?.event?.eventType,
                    item?.event?.eventName,
                    item?.event?.practiceName,
                    item?.eventMedia
                  )
                }
              >
                <img
                  src={getbackarrow}
                  alt="back"
                  className="getback"
                  onClick={() =>
                    storagePlaylist(
                      item?.scheduleDetails?.season?.years,
                      item?.event?.seasonType,
                      `${item?.seasonWeeks?.title} - ${item?.school2Name}`,
                      item?.event?.eventType,
                      item?.event?.eventName,
                      item?.event?.practiceName,
                      item?.eventMedia?.scheduleEvent?.schYear
                    )
                  }
                />
                Get Back Here
              </button>
            </div>
          </div>
          <div className="col-lg-3 col-md-3">
            <div className="clear20"></div>
            <video
              src={item?.thumbnailUrl}
              alt="coach"
              className="thumbnail-3"
            ></video>
          </div>
        </div>
      </div>
    );
  };

  const videoSharedContainer = (item, index) => {
    return (
      <div
        className="main-card-box pd-10 brd-grey position-relative"
        key={index}
      >
        <div className="row pad-bottom-10  brderbtm">
          <div className="d-flex-space-between flex-wrap w-100">
            {item?.groupShare && item?.groupShare.length > 0 ? (
              <p className="fs-16 semi-bold">
                {`${item?.shareBy?.firstName} Shared Video To ${item?.groupShare
                  .toString()
                  .replaceAll(",", ", ")}`}
              </p>
            ) : (
              <p className="fs-16 semi-bold">
                {item?.shareBy?.firstName} shared video to{" "}
                {convertArrToString(item?.coachShare)}
                {item?.athleteShare && item?.coachShare.length > 0 && ", "}
                {convertArrToString(item?.athleteShare)}
              </p>
            )}
            <div>
              <span className="semi-bold">{item?.lastSeen}</span>
            </div>
          </div>
        </div>
        <SharedVideoDetails item={item} />
      </div>
    );
  };

  const renderSwitch = (item, index) => {
    switch (item.type) {
      case "MEMBER_ADDED":
        return MembersAddedContainer(item, index);

      case "VIDEO_EDIT":
        return videoEditsContainer(item, index);

      case "VIDEO_SHARED":
        return videoSharedContainer(item, index);

      case "SEASON_ADDED":
        return SeasonAddedContainer(item, index);

      case "SCHEDULE_ADDED":
        return EventsAddedContainer(item, index);
      default:
        return;
    }
  };

  const listInnerRef = useRef();

  const onScrollActivity = () => {
    if (
      activityHistoryData?.pageNumber <= activityHistoryData?.totalPages - 1 &&
      !activityHistoryData?.loading
    ) {
      if (listInnerRef.current) {
        const { scrollTop, scrollHeight, clientHeight } = listInnerRef.current;
        if (Math.round(scrollTop + 1 + clientHeight) >= scrollHeight) {
          getAllActivityHistory(dispatch, {
            pageNumber: activityHistoryData?.pageNumber,
            status: false,
          });
        }
      }
    }
  };

  return (
    <div className="position-relative">
      <div
        className="height-350 overflow-y custom-scrollbar-container"
        onScroll={() => onScrollActivity()}
        ref={listInnerRef}
      >
        {activityHistoryData?.activityData?.AllActivity?.map((item, index) =>
          renderSwitch(item, index)
        )}

        {!activityHistoryData?.loading &&
          !activityHistoryData?.error &&
          activityHistoryData?.activityData?.AllActivity?.length == 0 && (
            <Paper className="activity-trending-container2  pd-10 mg-top-10">
              <p className="nodatabox">
                No feed available currently. Once you or your Coaches, Athletes
                share the content, it will become available here
              </p>
            </Paper>
          )}
        {!activityHistoryData?.loading && activityHistoryData?.error && (
          <p className="nodatabox">
            <Paper className="activity-trending-container2  pd-10 mg-top-10">
              <p className="nodatabox">{activityHistoryData?.error?.message}</p>
            </Paper>
          </p>
        )}
      </div>
      <div
        className="activity-history-loading-container"
        hidden={!activityHistoryData?.loading}
      >
        <div className="shadow bg-white position-absolute rounded-circle p-2 loading-background d-flex justify-content-center align-items-center">
          <CircularProgress
            className="rounded-circle"
            color="success"
            sx={{ fontSize: 10, color: "#002244" }}
            disableShrink
          />
        </div>
      </div>
    </div>
  );
};

export default AllActivity;
